var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getSelectedCompany())?_c('div',{staticClass:"monitoring__columns"},_vm._l((_vm.monitored_locations),function(location){return _c('location-column',{key:location.id,attrs:{"location":location}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }